import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import "./form-dialog.scss";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Axios from "axios";
import { Dropdown } from "semantic-ui-react";
import $ from "jquery";
import ConfirmSaveAccountPricingDialog from "./ConfirmSaveAccountPricingDialog";

import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";

import Translated from "../Translated/Translated";
import translator from "../../utils/translator";

function FormDialog(props) {
	const [open, setOpen] = React.useState(false);

	// here are the only states you will need
	// NOTE: IT MIGHT CRASH DUE TO ME CHANGING THE EMPTY STRING DEFAULT VALUE TO NULL. MAYBE I DIDN'T TEST IT SO IM WRITING THIS REMOVE THIS COMMENT LATER
	const [markupAmount, setMarkupAmount] = useState(null); // Should have not called this mark up amount. Should have called it amount because we will be using this state for discount amount as well. Don't feel like refactoring the code because I used this state in a lot of places
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [listOfShipTos, setListOfShipTos] = useState([]);
	const [showPricing, setShowPricing] = useState(null);
	const [amountLabel, setAmountLabel] = useState(null);
	const [project_allowance_amount, setProject_allowance_amount] = useState(null);
	const [listOfAccounts, setListOfAccounts] = useState([]);
	const [pricingSettingsExist, setPricingSettingsExist] = useState(null);
	const [alt_pricing_account_name, set_alt_pricing_account_name] = useState(null);
	const [alt_ship_to, set_alt_ship_to] = useState(null);
	const [alt_pricing_account_id, set_alt_pricing_account_id] = useState(null);
	const [allowance_type, set_allowance_type] = useState("4");

	const allowance_list = [
		{ value: "1", label: translator("Admin Pricing", "project_label") },
		{ value: "3", label: translator("Admin Pricing", "product_label") },
		{ value: "4", label: translator("Admin Pricing", "none_label") }
	];

	const inputNumberBlockedChars = [ 'e', 'E', '+', '-'];

	async function handleClickOpen() {
		let checkIfWarehouseExistAPIUrl = props.APIUrl + "/settings/warehouse-exist";

		let warehouseData = {
			warehouseNumber: props.warehouseNumber
		};

		let checkIfWarehouseExistAPIResponse = await Axios.post(
			checkIfWarehouseExistAPIUrl,
			warehouseData
		);
		if (
			checkIfWarehouseExistAPIResponse.data.doesWarehouseExist === true &&
			props.accountName &&
			props.actingAsAnAgent
		) {
			let getAccountPricingApiUrl = props.APIUrl + "/settings/account-pricing";
			let data = {
				projectID: props.projectID
			};

			let getAccountPricingApiResponse = await Axios.post(getAccountPricingApiUrl, data);
			console.log("here is the value for account pricing ", getAccountPricingApiResponse);
			let accountPricingSettings = getAccountPricingApiResponse.data.project_pricing;
			if (accountPricingSettings === null) {
				setShowPricing(true);
				setMarkupAmount(0);
				setProject_allowance_amount(0);

				// we will need this when sending to back end to create a new pricing setting
				setPricingSettingsExist(false);
			} else {
				// NOTE: some of the values may be null if the pricing type id is not 3 which refers to another account and therefore alt_ship_to and alt_account_name will be null

				// States that has value if pricing_type_id is 3 (another account) REMEMBER some of these values are null depending on which pricing type they selected. I set the state for those values anyways because it wont crash if they are null and the code seems more cleaner this way.
				set_alt_pricing_account_name(accountPricingSettings.alt_pricing_account_name);
				set_alt_ship_to(accountPricingSettings.alt_ship_to);
				set_alt_pricing_account_id(accountPricingSettings.alt_pricing_account_id);

				listOfAccounts.push({
					text: accountPricingSettings.alt_pricing_account_name,
					value: accountPricingSettings.alt_pricing_account_id
				});
				setListOfAccounts(listOfAccounts);

				listOfShipTos.push({
					text:
						accountPricingSettings.alt_ship_to +
						" | " +
						accountPricingSettings.alt_pricing_account_id,
					value: accountPricingSettings.alt_ship_to
				});
				setListOfShipTos(listOfShipTos);

				// states that has value if pricing_type_id is 1 and 2 (MSRP, account plus)
				setMarkupAmount(accountPricingSettings.margin);
				setShowPricing(accountPricingSettings.show_pricing_to_customer ? true : false);
				setPricingSettingsExist(true);
				set_allowance_type("" + accountPricingSettings.allowance_type);
				setProject_allowance_amount(accountPricingSettings.project_allowance);
			}
			setOpen(true);

			// If you are wondering why i'm using jquery instead of manually making it checked its because it throws an error
			// don't want to get into detail or this comment will be too long.
			if (accountPricingSettings === null) {
				$("input:radio[name=inlineRadioOptions]")[0].checked = true;
			} else {
				$("input:radio[name=inlineRadioOptions]")[
					accountPricingSettings.pricing_type_id
				].checked = true;
			}

			// Set the amount label
			if (accountPricingSettings === null || accountPricingSettings.pricing_type_id === 1) {
				setAmountLabel(translator("Admin Pricing", "margin_amount_label"));
			} else if (accountPricingSettings.pricing_type_id === 2) {
				setAmountLabel(translator("Admin Pricing", "discount_amount_label"));
			} else if (accountPricingSettings.pricing_type_id === 3) {
				setAmountLabel(translator("Admin Pricing", "pricing_account_label"));
			}
		} else {
			props.toastFromSetProjectPricingChildComponent(
				true,
				translator("Project Setup", "set_pricing_error")
			);
		}
	}

	function handleClose() {
		setOpen(false);
	}

	const getShipTosForThisAccountId = async (eventTargetValue, event) => {
		let selectedAccountName = event.target.textContent;
		if (eventTargetValue) {
			console.log("we made it here ", eventTargetValue);
			await set_alt_pricing_account_id(eventTargetValue);
			await set_alt_pricing_account_name(selectedAccountName);

			await set_alt_ship_to("");
		}
		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");

		const getShipToAPIUrl = props.APIUrl + "/projects/fetch-ship-to";

		const data = {
			token,
			trendId,
			projectAccountId: eventTargetValue ? eventTargetValue : alt_pricing_account_id, // THIS IS WHERE I LEFT OFF. FOR SOME REASON ACCOUNT ID SET STATE IS NOT BEING SYNCHRNOUS. So, it gets to the backend as being null.
			warehouse: props.warehouseNumber
		};

		const getShipToAPIResponse = await Axios.post(getShipToAPIUrl, data);
		console.log("api response ", getShipToAPIResponse);
		let listOfShipTosFromTrend = getShipToAPIResponse.data.listOfShipTosFromTrend;

		const listOfShipTos = [];

		// The reason we have an else statement here is because it crashes when you loop through a non array
		// so the else statement does not have a for loop.
		if (Array.isArray(listOfShipTosFromTrend)) {
			for (let i = 0; i < listOfShipTosFromTrend.length; i++) {
				let formatDataForDropDown = {
					text:
						listOfShipTosFromTrend[i].ShipTo +
						" | " +
						listOfShipTosFromTrend[i].CustomerNumber,
					value: listOfShipTosFromTrend[i].ShipTo
				};

				listOfShipTos.push(formatDataForDropDown);
			}
		} else if (listOfShipTosFromTrend === undefined) {
			// DO NOTHING. I know this seems sloppy but I mean it really isn't a big deal and not worth my time to find a logical way for ONLY and if and else
		} else {
			let formatDataForDropDown = {
				text: listOfShipTosFromTrend.ShipTo + " | " + listOfShipTosFromTrend.CustomerNumber,
				value: listOfShipTosFromTrend.ShipTo
			};

			listOfShipTos.push(formatDataForDropDown);
		}
		await setListOfShipTos(listOfShipTos);
	};

	const searchAccounts = query => {
		window.clearTimeout(searchTimeout);

		setSearchTimeout(window.setTimeout(getAccounts, 500, query));
	};

	const getAccounts = async query => {
		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");

		const getAccountInformationAPIUrl = props.APIUrl + "/settings/account-information";

		const data = {
			trendId,
			token,
			searchTerm: query,
			warehouse: props.warehouseNumber
		};

		const getAccountInformationApiResponse = await Axios.post(
			getAccountInformationAPIUrl,
			data
		);
		let listOfAccountsFromTrend =
			getAccountInformationApiResponse.data.getAccountInformationTrendResponse;

		let listOfAccounts = [];

		if (Array.isArray(listOfAccountsFromTrend)) {
			for (let i = 0; i < listOfAccountsFromTrend.length; i++) {
				let formatDataForInputDropDown = {
					text: listOfAccountsFromTrend[i].Name 
					+ ' | ' + listOfAccountsFromTrend[i].CustomerNumber,
					value: listOfAccountsFromTrend[i].CustomerNumber
				};

				listOfAccounts.push(formatDataForInputDropDown);
			}
			setListOfAccounts(listOfAccounts);
		} else if (listOfAccountsFromTrend) {
			let formatDataForInputDropDown = {
				text: listOfAccountsFromTrend.Name,
				value: listOfAccountsFromTrend.CustomerNumber
			};
			listOfAccounts.push(formatDataForInputDropDown);
			setListOfAccounts(listOfAccounts);
		} else {
			setListOfAccounts([]);
		}
	};

	const saveAccountPricing = async () => {
		try {
			if (markupAmount <= 1) {
				let updateAccountPricingInformation =
					props.APIUrl + "/settings/update-account-pricing";
				let pricing_type_id = $("input[name='inlineRadioOptions']:checked").val();

				let data = pricingSettingsExist
					? {
						project_ID: props.projectID,
						updatedMarkUpAmount: markupAmount,
						updatedPricingTypeId: pricing_type_id,
						updatedShowPricingToCustomer: showPricing ? 1 : 0,
						alt_ship_to: alt_ship_to,
						alt_pricing_account_name: alt_pricing_account_name,
						alt_pricing_account_id: alt_pricing_account_id,
						allowance_type: parseInt(allowance_type),
						updated_project_allowance_amount: project_allowance_amount,
						language: props.selected_language
					}
					: {
						project_ID: props.projectID,
						updatedMarkUpAmount: markupAmount,
						updatedPricingTypeId: pricing_type_id,
						updatedShowPricingToCustomer: showPricing ? 1 : 0,
						trendId: localStorage.getItem("trendId"), // this is the only difference from the above object. We need this since we are creating a new record
						alt_ship_to: alt_ship_to,
						alt_pricing_account_name: alt_pricing_account_name,
						alt_pricing_account_id: alt_pricing_account_id,
						allowance_type: parseInt(allowance_type),
						updated_project_allowance_amount: project_allowance_amount
					};

				await Axios.post(
					updateAccountPricingInformation,
					data
				);

				props.toastFromSetProjectPricingChildComponent(
					false,
					translator("Misc", "update_success")
				);

				handleClose();
			} else {
				// SEND THEM A VALIDATION. USING TOAST
				props.toastFromSetProjectPricingChildComponent(
					true,
					translator("Misc", "margin_invalid")
				);
			}
		} catch (error) {
			console.log(
				"here is the error message when saving the account pricing information ",
				error.message
			);
		}
	};

	const checkIfBlockedChar = event => {
		if(inputNumberBlockedChars.includes(event.key)) {
			event.preventDefault();
		}
	}

	const render_pricing_settings = () => {
		return (
			<>
				<div style={{ marginTop: "3em" }} class="form-group">
					{/* The label that displays when you select another account is pricing account */}
					{amountLabel === translator("Admin Pricing", "pricing_account_label") ? (
						<React.Fragment>
							<label>{amountLabel}</label>
							<Dropdown
								placeholder={translator("Misc", "account_label")}
								fluid
								search={(options, query) => options}
								selection
								options={listOfAccounts}
								onChange={(event, { value }) =>
									getShipTosForThisAccountId(value, event)
								}
								onSearchChange={(e, d) => {
									searchAccounts(d.searchQuery);
								}}
								value={alt_pricing_account_id}
							/>
							<Dropdown
								placeholder={
									listOfShipTos.length > 0
										? translator("Project Setup", "ship_to_label")
										: translator("Misc", "no_ship_to_with_account")
								}
								fluid
								selection
								options={listOfShipTos}
								onChange={(event, { value }) => set_alt_ship_to(value)}
								value={alt_ship_to}
							/>
						</React.Fragment>
					) : (
							<React.Fragment>
								<label>{amountLabel}</label>
								<input
									type="number"
									class="form-control settings-form"
									onKeyDown={e => checkIfBlockedChar(e)}
									onChange={event => setMarkupAmount(event.target.value)}
									value={markupAmount}
								/>
							</React.Fragment>
						)}
				</div>

				<div style={{ marginTop: "7em" }} class="form-group">
					<FormLabel component="legend">
						<Translated section="Admin Pricing" label="allowance_type_label" />
					</FormLabel>
					<RadioGroup
						name="allowance-type"
						value={allowance_type}
						onChange={e => {
							set_allowance_type(e.target.value);
						}}
					>
						{allowance_list.map(allowance_item => (
							<FormControlLabel
								style={{ marginBottom: "0" }}
								value={allowance_item.value}
								control={<Radio style={{ padding: "0.2em" }} color="primary" />}
								label={allowance_item.label}
							/>
						))}
					</RadioGroup>

					{allowance_type === "1" ? (
						<div>
							<FormLabel style={{ marginTop: "1em" }}>
								<Translated
									section="Admin Pricing"
									label="project_allowance_label"
								/>
							</FormLabel>
							<input
								type="number"
								class="form-control settings-form"
								onKeyDown={e => checkIfBlockedChar(e)}
								onChange={event => setProject_allowance_amount(event.target.value)}
								value={project_allowance_amount}
							/>
						</div>
					) : (
							""
						)}
				</div>

				<ConfirmSaveAccountPricingDialog
					saveAccountPricing={saveAccountPricing}
					markupAmount={markupAmount}
					toastFromSetProjectPricingChildComponent={
						props.toastFromSetProjectPricingChildComponent
					}
					project_allowance_amount={project_allowance_amount}
				/>
			</>
		);
	};

	return (
		<div class="form-dialog-container">
			<Button
				style={{ whiteSpace: "normal" }}
				variant="outlined"
				color="primary"
				onClick={handleClickOpen}
			>
				{translator("Admin Pricing", "page_title")}
			</Button>

			<Dialog
				scroll={"body"}
				fullWidth={true}
				maxWidth={"xs"}
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					<Translated section="Admin Pricing" label="page_title" />{" "}
					<Button id="set-price-close-button" onClick={handleClose} color="primary">
						<i class="fa fa-window-close fa-2x" aria-hidden="true" />
					</Button>
				</DialogTitle>
				<DialogContent>
					<RadioGroup className="set-pricing-radio-group">
						<label style={{ marginRight: "1em" }}>
							<Translated section="Admin Pricing" label="pricing_type_label" />:
						</label>
						<div class="form-check form-check-inline">
							<input
								class="form-check-input"
								type="radio"
								name="inlineRadioOptions"
								id="AccountPlus"
								value="1"
								onClick={event => setAmountLabel("Markup Percentage")}
							/>
							<label class="form-check-label" for="AccountPlus">
								{translator("Admin Pricing", "none_label")}
							</label>
						</div>

						<div class="form-check form-check-inline">
							<input
								class="form-check-input"
								type="radio"
								name="inlineRadioOptions"
								id="AccountPlus"
								value="1"
								onClick={event => {
									setAmountLabel("Markup Percentage");
								}}
							/>
							<label class="form-check-label" for="AccountPlus">
								<Translated section="Admin Pricing" label="account_plus_label" />
							</label>
						</div>
						<div class="form-check form-check-inline">
							<input
								class="form-check-input"
								type="radio"
								name="inlineRadioOptions"
								id="MSRP Down"
								value="2"
								onClick={event => {
									setAmountLabel("Discount Percentage");
								}}
							/>
							<label class="form-check-label" for="MSRPDown">
								<Translated section="Admin Pricing" label="msrp_label" />
							</label>
						</div>
						<div class="form-check form-check-inline">
							<input
								class="form-check-input"
								type="radio"
								name="inlineRadioOptions"
								id="AnotherAccount"
								value="3"
								onClick={event => setAmountLabel("Pricing Account")}
							/>
							<label class="form-check-label" for="AnotherAccount">
								<Translated section="Admin Pricing" label="option_3_label" />
							</label>
						</div>
						<div class="form-check form-check-inline">
							<input
								class="form-check-input"
								type="checkbox"
								name="ShowPricing"
								id="ShowPricing"
								value="option4"
								onClick={event => {
									setShowPricing(!showPricing);
								}}
								defaultChecked={showPricing}
							/>
							<label class="form-check-label" for="ShowPricing">
								<Translated section="Admin Pricing" label="show_pricing_label" />
							</label>
						</div>
					</RadioGroup>
					{render_pricing_settings()}
				</DialogContent>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
